export enum LocalStorageKey {
    PREFIX = 'DIANA-',
    continuePath = 'CONTINUE_PATH',
    defaultTheme = 'DEFAULT_THEME',
    anonId = 'ANON_ID',
    guestUserQueryParams = 'GUEST_USER_QUERY_PARAMS',
}

const setPrefix = (key: string) => {
    if (!key.startsWith(LocalStorageKey.PREFIX)) {
        return `${LocalStorageKey.PREFIX}${key}`;
    }

    return key;
};

const getItem = (args: { key: LocalStorageKey | string }) => {
    return localStorage.getItem(setPrefix(args.key)) as string;
};

const setItem = (args: { key: LocalStorageKey | string; value: string }) => {
    localStorage.setItem(setPrefix(args.key), args.value);
};

const removeItem = (args: { key: LocalStorageKey | string }) => {
    localStorage.removeItem(setPrefix(args.key));
};

const getItemsKeys = () => Object.keys(localStorage);

const removeItems = () => {
    const localStorageKeys = getItemsKeys().filter((e) => e.startsWith(LocalStorageKey.PREFIX));
    localStorageKeys.forEach((e) => localStorageUtil.removeItem({ key: e }));
};

export const localStorageUtil = {
    setPrefix,
    setItem,
    getItem,
    removeItem,
    getItemsKeys,
    removeItems,
};
